export default __webpack_public_path__ + "static/media/1.9ab6123b.png";